import React, { useEffect } from "react";
import MetricCards from "./MetricCards";
import ChartsSection from "./ChartsSection";
import DateRangeSelector from "./DashboardDateFilter";
import TableSection from "./TableSection";
import { useTranslation } from "react-i18next";
import { HomeOutlined } from "@ant-design/icons";
import { useBreadcrumbs } from "../../../context/breadcrumbs";

import styles from "./index.module.scss";

export default function DashboardContent(): React.ReactNode | null {
  const { t, i18n } = useTranslation();
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      { title: <HomeOutlined />, href: "/" },
      { title: t("routes.dashboard") },
    ]);
  }, [i18n.language, t]);

  return (
    <div style={{ background: "none" }}>
      <div className={styles.title}>
        <h2>{t("routes.dashboard")}</h2>
        <DateRangeSelector />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <MetricCards />
        <ChartsSection />
        <TableSection />
      </div>
    </div>
  );
}
